export default __webpack_public_path__ + "assets/webgl/complete-9.1703baa7.jpg";